import React from "react";
import "./Carousel.css";
import { useEffect, useState } from "react";
import logo from "../../Assets/logo.png"

const Carousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      imageUrl:
        "https://cdn.prod.website-files.com/5b044d009105d3778c5b7e1e/5b050dc1abbf2637bca31256_P1070397.jpg",
      alt: "image1",
    },
    {
      imageUrl:
        "https://cdn.prod.website-files.com/5b044d009105d3778c5b7e1e/5b044d84154674d7602b23dd_herobg02.jpg",
      alt: "image2",
    },
    {
      imageUrl:
        "https://cdn.prod.website-files.com/5b044d009105d3778c5b7e1e/5b050dc1a6d00b7a5aa06597_P1070707.jpg",
      alt: "image3",
    },
    {
      imageUrl:
        "https://cdn.prod.website-files.com/5b044d009105d3778c5b7e1e/5b050dc2fc1fa2023ee8bcc9_P1070744.jpg",
      alt: "image4",
    },
    {
      imageUrl:
        "https://cdn.prod.website-files.com/5b044d009105d3778c5b7e1e/5b050dc1a7ce347bc9a3c12c_P1070725.jpg",
      alt: "image5",
    },
  ];
  

  useEffect(() => {
    const interval = setInterval(() => {
      nextImage();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const nextImage = () => {
    setCurrentSlide((prevIndex) => (prevIndex + 1) % slides.length);
  };
  const prevImage = () => {
    setCurrentSlide(
      (prevIndex) => (prevIndex - 1 + slides.length) % slides.length
    );
  };
  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="kryesorja-about">
      <div className="carouselabout">
        <img
          src={slides[currentSlide].imageUrl}
          alt={slides[currentSlide].alt}
        />

        <div className="indicators">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`indicator ${currentSlide === index ? "active" : ""}`}
              onClick={() => goToSlide(index)}
            ></button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Carousel;
